module.exports = __webpack_public_path__ + "img/comments.b94679c3.svg";